/*
 * The canvas's two views, above it: the summary (PipelineCanvas, the
 * totals at each step) or one pipeline per active isolate
 * (IsolatePipelines, the same rows as the table below). Two buttons that
 * say which is pressed, not a toggle whose state is only a colour.
 *
 * Shown only to a reader with lab visibility: "My isolates" has no lab
 * pipeline for an isolate to be drawn along.
 */
export const CANVAS_MODES = ['summary', 'isolates'];

export default function CanvasModeSwitch({ mode, onChange, t }) {
  const buttons = [
    { key: 'summary', label: t('canvasMode.summary'), tip: t('tip.canvasMode.summary') },
    { key: 'isolates', label: t('canvasMode.isolates'), tip: t('tip.canvasMode.isolates') },
  ];
  return (
    <div className="hub-modes" role="group" aria-label={t('canvasMode.label')} data-testid="hub-modes">
      {buttons.map((b) => {
        const on = mode === b.key;
        return (
          <button key={b.key} type="button" className="hub-mode" aria-pressed={on} title={b.tip}
            onClick={() => onChange(b.key)} data-testid={`hub-mode-${b.key}`}>
            {/* Pressed is said by a mark as well as the fill. */}
            {on && <span aria-hidden="true">✓ </span>}
            {b.label}
          </button>
        );
      })}
    </div>
  );
}
